import axios from "axios";
import { apiUrl } from "../../constant";
import {
    getCarrierConnectListingService,
    getCarrierConnectByIdService,
    createCarrierConnectService,
    updateCarrierConnectMediaService,
    updateCarrierConnectDataService,
    deleteCarrierConnectService,
    getCarrierConnectHistoryService,
    getAllCarrierConnectCarriersService,
    getAllCarrierConnectTypesService,
    getAllCarrierConnectStatusService,
} from "../../services/carrierConnect.service";
import { toast } from "react-toastify";

// Action Types
export const GET_CARRIER_CONNECT_LISTING_REQUEST = 'GET_CARRIER_CONNECT_LISTING_REQUEST';
export const GET_CARRIER_CONNECT_LISTING_SUCCESS = 'GET_CARRIER_CONNECT_LISTING_SUCCESS';
export const GET_CARRIER_CONNECT_LISTING_FAILURE = 'GET_CARRIER_CONNECT_LISTING_FAILURE';

export const GET_CARRIER_CONNECT_BY_ID_REQUEST = 'GET_CARRIER_CONNECT_BY_ID_REQUEST';
export const GET_CARRIER_CONNECT_BY_ID_SUCCESS = 'GET_CARRIER_CONNECT_BY_ID_SUCCESS';
export const GET_CARRIER_CONNECT_BY_ID_FAILURE = 'GET_CARRIER_CONNECT_BY_ID_FAILURE';

export const CREATE_CARRIER_CONNECT_REQUEST = 'CREATE_CARRIER_CONNECT_REQUEST';
export const CREATE_CARRIER_CONNECT_SUCCESS = 'CREATE_CARRIER_CONNECT_SUCCESS';
export const CREATE_CARRIER_CONNECT_FAILURE = 'CREATE_CARRIER_CONNECT_FAILURE';

export const UPDATE_CARRIER_CONNECT_REQUEST = 'UPDATE_CARRIER_CONNECT_REQUEST';
export const UPDATE_CARRIER_CONNECT_SUCCESS = 'UPDATE_CARRIER_CONNECT_SUCCESS';
export const UPDATE_CARRIER_CONNECT_FAILURE = 'UPDATE_CARRIER_CONNECT_FAILURE';

export const DELETE_CARRIER_CONNECT_REQUEST = 'DELETE_CARRIER_CONNECT_REQUEST';
export const DELETE_CARRIER_CONNECT_SUCCESS = 'DELETE_CARRIER_CONNECT_SUCCESS';
export const DELETE_CARRIER_CONNECT_FAILURE = 'DELETE_CARRIER_CONNECT_FAILURE';

export const TEST_CARRIER_CONNECTION_REQUEST = 'TEST_CARRIER_CONNECTION_REQUEST';
export const TEST_CARRIER_CONNECTION_SUCCESS = 'TEST_CARRIER_CONNECTION_SUCCESS';
export const TEST_CARRIER_CONNECTION_FAILURE = 'TEST_CARRIER_CONNECTION_FAILURE';

export const GET_CARRIER_CONNECT_CARRIERS_SUCCESS = 'GET_CARRIER_CONNECT_CARRIERS_SUCCESS';
export const GET_CARRIER_CONNECT_TYPES_SUCCESS = 'GET_CARRIER_CONNECT_TYPES_SUCCESS';
export const GET_CARRIER_CONNECT_STATUS_SUCCESS = 'GET_CARRIER_CONNECT_STATUS_SUCCESS';

export const GET_CARRIER_CONNECT_HISTORY_REQUEST = 'GET_CARRIER_CONNECT_HISTORY_REQUEST';
export const GET_CARRIER_CONNECT_HISTORY_SUCCESS = 'GET_CARRIER_CONNECT_HISTORY_SUCCESS';
export const GET_CARRIER_CONNECT_HISTORY_FAILURE = 'GET_CARRIER_CONNECT_HISTORY_FAILURE';

// Action Creators
export const getCarrierConnectListing = (data) => async (dispatch) => {
    try {
        dispatch({ type: GET_CARRIER_CONNECT_LISTING_REQUEST });
        
        const response = await getCarrierConnectListingService(data);
        
        // Check if HTTP request was successful
        if (response?.status === 200 && response.data) {
            // Handle different response structures - check for Entity vs entity vs direct data
            let listingData = response.data.Entity || response.data.entity || response.data;
            
            if (listingData) {
                // Ensure compatibility: if listingData has CarrierConnections, create EntityList
                if (listingData.CarrierConnections && !listingData.EntityList) {
                    listingData.EntityList = listingData.CarrierConnections;
                }
                
                dispatch({
                    type: GET_CARRIER_CONNECT_LISTING_SUCCESS,
                    payload: listingData
                });
                return { success: true, payload: listingData };
            } else {
                // API returned 200 but no valid data
                const errorMessage = response.data.Message || response.data.message || 'No data found for carrier connect listing';
                dispatch({
                    type: GET_CARRIER_CONNECT_LISTING_FAILURE,
                    payload: errorMessage
                });
                toast.error(errorMessage);
                return { success: false, error: errorMessage };
            }
        } else {
            // HTTP request failed or no response data
            const errorMessage = response?.data?.Message || response?.data?.message || 'Failed to fetch carrier connections';
            dispatch({
                type: GET_CARRIER_CONNECT_LISTING_FAILURE,
                payload: errorMessage
            });
            toast.error(errorMessage);
            return { success: false, error: errorMessage };
        }
    } catch (error) {
        const errorMessage = error.response?.data?.Message || error.response?.data?.message || error.message || 'Something went wrong while fetching carrier connections';
        dispatch({
            type: GET_CARRIER_CONNECT_LISTING_FAILURE,
            payload: errorMessage
        });
        toast.error(errorMessage);
        return { success: false, error: errorMessage };
    }
};

// Helper function to extract entity data from response
const extractEntityData = (response) => {
    return response.data.Entity || response.data.entity || response.data;
};

// Helper function to validate entity data
const isValidEntityData = (entityData) => {
    return entityData && (entityData.id || entityData.carrierConnectId || entityData.carrierConnectNumber);
};

// Helper function to get error message from response
const getResponseErrorMessage = (response, defaultMessage) => {
    return response?.data?.Message || response?.data?.message || defaultMessage;
};

// Helper function to handle successful entity retrieval
const handleEntitySuccess = (dispatch, entityData) => {
    dispatch({
        type: GET_CARRIER_CONNECT_BY_ID_SUCCESS,
        payload: entityData
    });
    return { success: true, payload: entityData };
};

// Helper function to handle entity retrieval failure
const handleEntityFailure = (dispatch, errorMessage) => {
    dispatch({
        type: GET_CARRIER_CONNECT_BY_ID_FAILURE,
        payload: errorMessage
    });
    return { success: false, message: errorMessage };
};

// Helper function to determine error message from caught error
const determineErrorMessage = (error) => {
    if (error.response) {
        // API responded with error status
        return error.response.data?.Message || 
               error.response.data?.message ||
               `Server error: ${error.response.status}`;
    } else if (error.request) {
        // Network error
        return 'Network error. Please check your connection and try again.';
    } else {
        // Other error
        return error.message || 'An unexpected error occurred';
    }
};

export const getCarrierConnectById = (id) => async (dispatch) => {
    try {
        dispatch({ type: GET_CARRIER_CONNECT_BY_ID_REQUEST });
        
        const response = await getCarrierConnectByIdService(id);
        
        // Check if HTTP request was successful
        if (response?.status === 200 && response.data) {
            const entityData = extractEntityData(response);
            
            if (isValidEntityData(entityData)) {
                return handleEntitySuccess(dispatch, entityData);
            } else {
                // API returned 200 but no valid entity data
                const errorMessage = getResponseErrorMessage(response, 'No data found for this carrier connect record');
                return handleEntityFailure(dispatch, errorMessage);
            }
        } else {
            // HTTP request failed or no data
            const errorMessage = getResponseErrorMessage(response, 'Failed to fetch carrier connection details');
            return handleEntityFailure(dispatch, errorMessage);
        }
    } catch (error) {
        const errorMessage = determineErrorMessage(error);
        return handleEntityFailure(dispatch, errorMessage);
    }
};

export const createCarrierConnect = (data) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_CARRIER_CONNECT_REQUEST });
        
        const response = await createCarrierConnectService(data);
        
        // Check the actual API response structure
        const statusCode = response?.data?.Status || response?.status;
        const responseData = response?.data;
        if (statusCode === 200) {
            dispatch({
                type: CREATE_CARRIER_CONNECT_SUCCESS,
                payload: responseData?.Entity
            });
            return { success: true, data: responseData };
        } else {
            // Handle error response with proper message structure
            const errorMessage = responseData?.Message?.AppStatusDescription || 
                               responseData?.Message?.AppStatusCode ||
                               responseData?.Message || 
                               'Failed to create carrier connection';
            dispatch({
                type: CREATE_CARRIER_CONNECT_FAILURE,
                payload: errorMessage
            });
            return { success: false, message: errorMessage };
        }
    } catch (error) {
        const errorMessage = extractApiErrorMessage(error);
        dispatch({
            type: CREATE_CARRIER_CONNECT_FAILURE,
            payload: errorMessage
        });
        return { success: false, message: errorMessage };
    }
};

export const deleteCarrierConnect = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_CARRIER_CONNECT_REQUEST });
        
        const response = await deleteCarrierConnectService(id);
        
        // Check the actual API response structure
        const statusCode = response?.data?.Status || response?.status;
        const responseData = response?.data;
        
        if (statusCode === 200) {
            dispatch({
                type: DELETE_CARRIER_CONNECT_SUCCESS,
                payload: id
            });
            return { success: true };
        } else {
            // Handle error response with proper message structure
            const errorMessage = responseData?.Message?.AppStatusDescription || 
                               responseData?.Message?.AppStatusCode ||
                               responseData?.Message || 
                               'Failed to delete carrier connection';
            dispatch({
                type: DELETE_CARRIER_CONNECT_FAILURE,
                payload: errorMessage
            });
            return { success: false, message: errorMessage };
        }
    } catch (error) {
        const errorMessage = extractApiErrorMessage(error);
        dispatch({
            type: DELETE_CARRIER_CONNECT_FAILURE,
            payload: errorMessage
        });
        return { success: false, message: errorMessage };
    }
};

// NEW: Update Carrier Connect Data Only (following inbound product pattern)
export const updateCarrierConnect = (data) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_CARRIER_CONNECT_REQUEST });
        
        const response = await updateCarrierConnectDataService(data);
        
        // Check the actual API response structure
        const statusCode = response?.data?.Status || response?.status;
        const responseData = response?.data;
        
        // Check for success: Status should be 200
        if (statusCode === 200) {
            dispatch({
                type: UPDATE_CARRIER_CONNECT_SUCCESS,
                payload: responseData?.Entity || responseData
            });
            return { success: true, data: responseData };
        } else {
            // Handle error response with proper message structure
            const errorMessage = responseData?.Message?.AppStatusDescription || 
                               responseData?.Message?.AppStatusCode ||
                               responseData?.message?.appStatusDescription || 
                               responseData?.Message ||
                               'Failed to update carrier connect';
            dispatch({
                type: UPDATE_CARRIER_CONNECT_FAILURE,
                payload: errorMessage
            });
            return { success: false, message: errorMessage };
        }
    } catch (error) {
        const errorMessage = extractApiErrorMessage(error);
        dispatch({
            type: UPDATE_CARRIER_CONNECT_FAILURE,
            payload: errorMessage
        });
        return { success: false, message: errorMessage };
    }
};

// Helper Actions for Dropdowns
export const getAllCarrierConnectCarriers = () => {
    return getAllCarrierConnectCarriersService();
};

export const getAllCarrierConnectTypes = () => {
    return getAllCarrierConnectTypesService();
};

export const getAllCarrierConnectStatus = () => {
    return getAllCarrierConnectStatusService();
};

export const getCarrierConnectHistory = (data) => async (dispatch) => {
    try {
        dispatch({ type: GET_CARRIER_CONNECT_HISTORY_REQUEST });
        
        const response = await getCarrierConnectHistoryService(data);
        
        // Check if HTTP request was successful
        if (response?.status === 200 && response.data) {
            // Check the API's internal status code in response body
            const apiStatus = response.data.Status || response.data.status;
            
            if (apiStatus === 200) {
                // Handle different response structures based on API spec
                let historyData = response.data.entity || response.data.Entity || response.data;
                
                // Extract carrier connects from the correct API response structure
                // API returns: { Entity: { TotalRecords: 1, CarrierConnects: [...] } }
                if (historyData?.CarrierConnects) {
                    // Transform the API response to match expected format
                    const transformedData = {
                        ...historyData,
                        carrierConnects: historyData.CarrierConnects, // Add lowercase version for component compatibility
                        TotalRecords: historyData.TotalRecords || 0
                    };
                    
                    dispatch({
                        type: GET_CARRIER_CONNECT_HISTORY_SUCCESS,
                        payload: transformedData
                    });
                    return { success: true, payload: transformedData };
                } else if (historyData && (historyData.carrierConnects || historyData.TotalRecords !== undefined)) {
                    dispatch({
                        type: GET_CARRIER_CONNECT_HISTORY_SUCCESS,
                        payload: historyData
                    });
                    return { success: true, payload: historyData };
                } else {
                    // API returned 200 but no valid data
                    const errorMessage = response.data.Message?.AppStatusDescription || 
                                       response.data.message?.appStatusDescription ||
                                       response.data.Message?.AppStatusCode ||
                                       response.data.message || 
                                       'No history data found for this carrier connect';
                    dispatch({
                        type: GET_CARRIER_CONNECT_HISTORY_FAILURE,
                        payload: errorMessage
                    });
                    toast.error(errorMessage);
                    return { success: false, error: errorMessage };
                }
            } else {
                // API returned HTTP 200 but internal status indicates error (like Status: 500)
                const errorMessage = response.data.Message?.AppStatusDescription || 
                                   response.data.Message?.AppStatusCode ||
                                   response.data.message?.appStatusDescription ||
                                   response.data.message || 
                                   'Failed to fetch carrier connect history';
                dispatch({
                    type: GET_CARRIER_CONNECT_HISTORY_FAILURE,
                    payload: errorMessage
                });
                toast.error(errorMessage);
                return { success: false, error: errorMessage };
            }
        } else {
            // HTTP request failed or no response data
            const errorMessage = response?.data?.Message?.AppStatusDescription || 
                               response?.data?.message?.appStatusDescription ||
                               response?.data?.message || 
                               'Failed to fetch carrier connect history';
            dispatch({
                type: GET_CARRIER_CONNECT_HISTORY_FAILURE,
                payload: errorMessage
            });
            toast.error(errorMessage);
            return { success: false, error: errorMessage };
        }
    } catch (error) {
        const errorMessage = error.response?.data?.Message?.AppStatusDescription || 
                           error.response?.data?.message?.appStatusDescription ||
                           error.response?.data?.Message?.AppStatusCode ||
                           error.response?.data?.message || 
                           error.message || 
                           'Something went wrong while fetching carrier connect history';
        dispatch({
            type: GET_CARRIER_CONNECT_HISTORY_FAILURE,
            payload: errorMessage
        });
        toast.error(errorMessage);
        return { success: false, error: errorMessage };
    }
};

export const updateCarrierConnectMedia = (data) => async (dispatch) => {
    try {
        const response = await updateCarrierConnectMediaService(data);
        return response;
    } catch (error) {
        throw error;
    }
};

// Helper to extract error message from API response
export function extractApiErrorMessage(error) {
    const responseData = error?.response?.data;
    return responseData?.Message?.AppStatusDescription ||
        responseData?.Message?.AppStatusCode ||
        responseData?.Message ||
        error?.message ||
        'Something went wrong';
}

export const deleteCarrierConnectRecords = (data) => {
    return axios.post(`${apiUrl}/api/CarrierConnect/DeleteCarrierConnects`, data);
};

export const updatePackageCount = (data) => {
    return axios.put(`${apiUrl}/api/CarrierConnect/UpdatePackageCount?${data}`);
};